import React from 'react'
import ReactDOM from 'react-dom'
import BrandLoader from '../BrandLoader/BrandLoader'

/*
 * Testing PayPal
 *
 * LastPass info noted below is a note in LastPass not a login and will not appear when using the browser extensions.
 *
 * customer (test buyer) account needs to be
 *   email: sb-eksyq6046128@personal.example.com
 *   pw: is in lastPass and can be found at https://developer.paypal.com/developer/accounts/
 *   under the manage accounts menu => View/edit account
 *     the account for developer.paypal is in lastpass under VERB PayPal Account
 *
 * You need
 * REACT_APP_ENABLE_PAYPAL=true
 * and
 * REACT_APP_PAYPAL_CLIENT_ID
 *    this is in https://developer.paypal.com/developer/applications/
 *    app name = Ferries DEV => Client ID
 *    OR - can be found in LastPass
 *
 * DOCS
 * CAPTURE
 * https://developer.paypal.com/docs/business/checkout/server-side-api-calls/capture-order/
 *
 * You can see your test transactions here
 *  https://www.sandbox.paypal.com/myaccount/
 * login using the sb-eksyq6046128@personal.example.com account above.
 *
 * ERRORS
 * https://developer.paypal.com/docs/business/checkout/server-side-api-calls/handle-funding-failures/
 *  FROM THE PAYPAL DOCS re denied payments:
 *  "If you're using actions.order.capture() in your client-side JavaScript code, don't complete this task. (this task being error handling)
 *  The script automatically restarts the Checkout flow and prompts the buyer to select a different funding source."
 *
 * CURRENCY
 * the currency is set when loading the script in App.js. Currencies can be found here...
 * https://developer.paypal.com/docs/business/javascript-sdk/javascript-sdk-configuration/#currency
 * although the docs at https://developer.paypal.com/docs/api/orders/v2/ say you can pass currency to  purchase_units
 * it will throw an error if it doesn't match the one set in the script, or if it is missing from the script. 🤷‍
 *
 * onShippingChange
 * There is a bug in PayPal that the button for Debit or Credit Card will open inline if clicked too fast and then fail to give any response
 * there is no explanation from PayPal or resolution to the issues opened (at the time of writing this comment)
 * https://github.com/paypal/paypal-checkout-components/issues/1479
 * and
 * https://github.com/paypal/paypal-checkout-components/issues/1521#issuecomment-821815565
 *
 * So far testing this seems to work. 🧐
 *
 * */

const PayPalButton = ({
  createParam,
  handleResponse,
  setLoading,
  loading,
  labels,
  onCancelTransaction
}) => {
  // createOrder MUST return actions.order.create or you get very misleading errors from PayPal.
  const createOrder = (data, actions) => actions.order.create(createParam)
  const onApprove = (data, actions) => {
    setLoading(true)
    return actions.order.capture().then(res => handleResponse(res))
  }

  const PayPalButtonInit = window?.paypal?.Buttons?.driver('react', {
    React,
    ReactDOM
  })

  return (
    // We can't unmount PayPalButtonInit while loading to show the spinner or we lose the connection
    // and therefor our response.
    <div className="paypal-button-container">
      <div className={`buttons ${loading ? 'hidden' : 'visible'}`}>
        <p className="payment-instructions">{labels.payPalCopy}</p>
        <PayPalButtonInit
          createOrder={(data, actions) => createOrder(data, actions)}
          onApprove={(data, actions) => onApprove(data, actions)}
          onShippingChange={(data, actions) => actions.resolve()} // see comment above
        />
        <button className="btn btn-secondary" onClick={onCancelTransaction}>
          {labels.cancel}
        </button>
      </div>
      {loading && (
        <div className="loader">
          <BrandLoader />
        </div>
      )}
    </div>
  )
}

export default PayPalButton
